/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { Tab } from '../../../core/model/tab.model';

/**
 * @export
 * @class LmsLocoInspectionComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-inspection',
  templateUrl: './lms-loco-inspection.component.html',
  styleUrls: ['./lms-loco-inspection.component.scss']
})
export class LmsLocoInspectionComponent implements OnInit, OnDestroy, OnChanges {


  @Input() locoData: LocoDetail;
  @Input() locoLabel: any;
  @Input() tab: Tab;
  @Input() group: any;
  @Input() errorMap: Map<string, boolean>;
  locoInspectionForm: UntypedFormGroup;
  minDateValue: Date = new Date(); //  Minimum value which can be selected from calendar
  minNextDateValue: Date = new Date();
  minNext33DaysDateValue: Date = new Date();
  minNextAirFlowDateValue: Date = new Date();

  /**
   * Creates an instance of LmsLocoInspectionComponent.
   * @memberOf LmsLocoInspectionComponent
   */
  constructor() { }

  /**
   * @memberOf LmsLocoInspectionComponent
   */
  ngOnInit() {
    this.minNextDateValue.setMonth((new Date()).getMonth() - 6);
    this.minNext33DaysDateValue.setMonth((new Date()).getMonth() - 6);
    this.minNextAirFlowDateValue.setMonth((new Date()).getMonth() - 6);
  }

  /**
   * @memberOf LmsLocoInspectionComponent
   */
  ngOnDestroy() {
  }

  /**
   * @memberOf LmsLocoInspectionComponent
   */
  ngOnChanges() {
    if (this.tab.mode === 'edit') {
      this.locoInspectionForm = this.group;
    }
  }

}
